import { h, Component, createRef, Fragment } from "preact";

import { classNames, renderIcon } from "../helpers";
import Dropdown from "./Dropdown.jsx";

export default function Filter(props) {
  const ref = createRef(ref);
  const selected = props.selected || "";
  const selectedOption = props.options.find(({ value }) => value === selected);

  function handleChange(event) {
    props.onChange(event);
    ref.current.close();
  }

  return (
    <Dropdown ref={ref} items={props.options} onClick={handleChange}>
      <a
        class={classNames(
          "filter__trigger t-body4 dropdown-trigger waves-effect waves-light ml-16",
          [selected && "filter__trigger--selected"]
        )}
        href="#"
        data-qa={props.dataQa}
      >
        {renderIcon(props.icon, "filter__icon")}
        {selectedOption?.text}
      </a>
    </Dropdown>
  );
}
